
import AddressService from '@/views/client/services/address-service'
import RepositoryService from '../../services/repository-service'
import FdaService from '../../services/fda-service'
import ClientModal from '@/views/client/components/ClientModal.vue'
import CompanyModal from '@/views/company/components/CompanyModal.vue'
import JobFormWindow from '@/views/job/components/Form/Form.vue'
import PreviewFda from '../FDA/Preview.vue'
import PrintFda from '../FDA/Print.vue'

import {
  AuthModule
} from '@/store/modules/AuthModule'
import {
  ToastModule
} from '@/store/modules/ToastModule'
import {
  Component,
  Vue
} from 'vue-property-decorator'
import DateHelper from '@/mixins/date-mixins'
import Currencies from '@/data/currency.json'
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue'
// import { MasterModule } from '@/store/modules/MasterModule'
import {
  NotifyModule
} from '@/store/modules/NotifyModule'
import {
  Validations
} from 'vuelidate-property-decorators'
import {
  Vuelidate
} from 'vuelidate'
import {
  required,
  helpers
} from 'vuelidate/lib/validators'
import draggable from 'vuedraggable'
import TariffModal from '../TariffModal.vue'
import TariffService from '../../services/tariff-service'
const alphatextarea = helpers.regex('alphatextarea', /^[\\/a-zA-Z0-9\s-/".,*"/gus]+$/)
  @Component({
    name: 'FDA',
    components: {
      VueAutonumeric,
      ClientModal,
      JobFormWindow,
      CompanyModal,
      TariffModal,
      PreviewFda,
      PrintFda,
      draggable
    }
  })
export default class FDA extends Vue {
    protected currencies = Currencies
    protected isEditForm = false
    protected isAdvanceReceived = false
    protected drag = false
    protected showComponent = false
    protected showAmountToWordsField = false
    protected document: any = null
    protected toWords: any = null
    protected clientAddress: any = null
    protected companyAddress: any = null
    protected companies: any = []
    protected clients: any = []
    protected services: any = []
    protected lines: any = []
    protected jobs: any = []
    protected job: any = {}
    protected contacts: any = []
    protected bankAccount: any = {}
    protected bankAccounts: any = []
    protected tariffs: any = []
    protected paymentMethods: any = ['Bank', 'Cheque', 'Cash']
    protected paymentMethod = null
    protected paymentTerms: any = []
    protected paymentTerm: any = {
      id: null,
      description: null
    }

    protected styles = ['https://api.smc-spl-application.com/print.css']

    protected header: any = {
      id: null,
      client: {},
      company: {},
      job: {},
      fda_date: null,
      fda_number: null,
      description: null,
      payment_method: null,
      currency: null,
      company_address: null,
      company_country: null,
      client_address: null,
      bank_account: {},
      total_quantity: null,
      oil_quantity: null,
      water_quantity: null,
      sub_total: null,
      advance_received: 0,
      total: null,
      memorandum: null,
      remark: null,
      created_user: null,
      modified_user: null
    }

    $v: Vuelidate

    @Validations()
    validations = {
      header: {
        client: {
          required
        },
        company: {
          required
        },
        job: {
          required
        },
        company_address: {
          alphatextarea
        },
        currency: {
          required
        },
        payment_method: {
          required
        },
        memorandum: {
          alphatextarea
        },
        remark: {
          alphatextarea
        }
      }
    }

    get SubTotal () {
      let amount = 0
      return this.lines.reduce((total, line) => {
        amount = (total + parseFloat((line.amount.toString()).replace(/,(?=\d{3})/g,
          '')))
        this.header.sub_total = amount
        return amount
      }, 0)
    }

    get Total () {
      const subTotal = this.SubTotal
      const advanceReceived = Number(this.header.advance_received) || 0
      const total = subTotal - advanceReceived
      this.header.total = total
      return total
    }

    get WaterQty () {
      const oil = Number(this.header.oil_quantity)
      const total = Number(this.header.total_quantity)

      if (isNaN(oil) || isNaN(total)) return ''

      const water = +(total - oil).toFixed(2)
      this.header.water_quantity = water
      return water
    }

    /* get isDataChange () {
      return MasterModule.master
    }

    @Watch('isDataChange', {
      deep: true
    })
    repopulate () {
      if (this.isDataChange.isOperationDataChanged) {
        this.populateJobs(this.header.client.id)
        this.populateJob(this.header.job.id)
        MasterModule.resetOperationChange()
      }
      if (this.isDataChange.isClientDataChanged) {
        this.populateClients()
        this.populateClientAddress(this.header.client.id)
        MasterModule.resetClientChange()
      }
      if (this.isDataChange.isCompanyDataChanged) {
        console.log('company', this.header.company.id)
        console.log('is changed', this.isDataChange.isCompanyDataChanged)
        console.log('company called')
        this.populateCompanies()
        this.populateCompanyAddress(this.header.company.id)
        this.populateBankAccounts()
        MasterModule.resetCompanyChange()
      }
    } */

    public show (item: any, transaction: any) {
      this.showComponent = true
      this.populateClients()
      this.populateCompanies()
      this.populateServices()
      this.populateTariffDetails()

      if (Object.keys(transaction).length !== 0) {
        this.isEditForm = true
        this.populateFDA(transaction)
      } else {
        this.isEditForm = false
        this.header.fda_date = DateHelper.today('dd/mm/yyyy')
        this.addLine()
        this.setFDA(item)
      }
    }

    public hide () {
      this.cancel()
      this.showComponent = false
    }

    protected showClientModal () {
      if (Object.keys(this.header.client).length === 0) return false;
      (this.$refs.ClientInfoModal as any).populateClient(this.header.client.id);
      (this.$refs.ClientInfoModal as any).open()
    }

    protected showCompanyModal () {
      if (Object.keys(this.header.company).length === 0) return false;
      (this.$refs.CompanyInfoModal as any).populateCompany(this.header.company.id);
      (this.$refs.CompanyInfoModal as any).open()
    }

    protected showJobWindow () {
      if (Object.keys(this.header.job).length === 0) return false;
      (this.$refs.JobFormWindow as any).show(this.header.job)
    }

    public showTariffModal () {
      (this.$refs.TariffDataModal as any).show('FDA')
    }

    protected async populateClients () {
      this.clients = []
      const response = await RepositoryService.getClients()
      this.clients = response.data
    }

    protected async populateBankAccounts () {
      this.bankAccounts = []
      if (!this.isEditForm) this.header.bank_account = {}
      this.bankAccount = {}
      if (this.header.payment_method === 'Bank' && this.header.company.id !== null && this.header.currency !== null) {
        const response = await FdaService.getBankAccounts(this.header.company.id, this.header.currency)
        response.data.forEach((element) => {
          this.bankAccounts.push({
            value: {
              id: element.id,
              name: element.bank_name + ' - ' + element.account_number
            },
            text: element.bank_name + ' - ' + element.account_number
          })
        })
      }
    }

    protected async populateBankAccount () {
      this.bankAccount = {}
      const response = await FdaService.getBankAccount(this.header.bank_account.id)
      this.bankAccount = response.data
    }

    protected async populateCompanies () {
      this.companies = []
      const response = await RepositoryService.getCompanies()
      response.data.forEach((company) => {
        this.companies.push({
          value: {
            id: company.id,
            name: company.name
          },
          text: company.name
        })
      })
    }

    protected populateServices () {
      this.services = []
      FdaService.getServices().then((response) => {
        response.data.forEach((service) => {
          this.services.push({
            value: {
              id: service.id,
              name: service.display_name,
              item_name: service.item_name,
              description: service.sales_description
            },
            text: service.display_name
          })
        })
      })
    }

    protected async populateJobs (AgentID: number) {
      this.jobs = []
      const response = await FdaService.getJobs(AgentID)
      this.jobs = response.data
    }

    protected populateJob (jobId: any) {
      FdaService.getJobDetails(jobId).then((response) => {
        this.job = response.data
        this.header.job = {
          id: response.data.id,
          number: response.data.job_number
        }
      })

      if (!this.isEditForm) this.setFdaNumber()
    }

    protected populateTariffDetails () {
      TariffService.getTariffDetails('FDA').then((response) => {
        if (response.data.length === 0) this.addLine()

        this.tariffs = response.data.map((tariff: any) => ({
          ...tariff,
          isEdit: false,
          item: {
            id: tariff.item_id,
            name: tariff.item_name
          },
          is_formula: tariff.is_formula === 1
        }))
      })
    }

    protected async setFdaNumber () {
      const response = await FdaService.getFdaRunningNumber()
      this.header.fda_number = 'FDA#' + DateHelper.year() + '/' + this.header.client.name.split(' ')[0] + '/' + String(response.data).padStart(3, '0')
    }

    protected setFDA (item: any = {}) {
      if (Object.keys(item).length === 0) return false
      this.header.client = {
        id: item.client_id,
        name: item.client_name
      }

      this.populateClientAddress(item.client_id)
      this.populateJob(item.id)
    }

    protected populateFDA (transaction: any) {
      FdaService.getFDADetails(transaction.source_id).then((response) => {
        this.header = response.data
        this.header.company = {
          id: response.data.company_id,
          name: response.data.company_name
        }
        this.header.client = {
          id: response.data.client_id,
          name: response.data.client_name
        }
        this.header.bank_account = {
          id: response.data.bank_account_id,
          name: response.data.bank_account_name
        }
        this.header.job = {
          id: null,
          number: null
        }
        this.header.total_quantity = Number(response.data.total_quantity)
        this.header.oil_quantity = Number(response.data.oil_quantity)

        this.populateJob(transaction.reference_id)
        this.populateJobs(response.data.client_id)

        this.populateBankAccounts()
        this.populateBankAccount()

        this.lines = response.data.lines.map(line => ({
          ...line,
          isEdit: false,
          item: {
            id: line.item_id,
            name: line.item_name,
            description: line.description
          },
          rate_selection: Number(line.rate_selection) === 1 ? Number(line.rate_selection) : line.rate_selection,
          is_custom_rate: Number(line.rate_selection) === 1,
          custom_rate: Number(line.rate_selection) === 1 ? line.rate : null,
          tariffs: []
        }))

        this.lines.forEach((line, index) => {
          this.getTariffDetailsByItemId(line.item, index)
        })
      })
    }

    protected editLine (lineIndex: number) {
      this.lines[lineIndex].isEdit = !this.lines[lineIndex].isEdit
    }

    protected addLine () {
      this.lines.push({
        id: null,
        isEdit: true,
        line_number: null,
        item: {},
        description: null,
        quantity: null,
        rate: null,
        rate_selection: null,
        is_custom_rate: false,
        custom_rate: null,
        tariffs: [],
        amount: 0,
        created_user: null
      })
    }

    protected deleteLine (line, tableIndex) {
      const msg = `Are you sure you want to delete line ${tableIndex + 1}?`
      if (confirm(msg)) {
        if (line.id !== null) {
          FdaService.deleteItemLine(this.header.id, line.id)
            .then(response => {
              ToastModule.message(response.data.message)
              this.lines.splice(tableIndex, 1)
            })
            .catch(error => ToastModule.message(error.response.data.message))
        } else this.lines.splice(tableIndex, 1)
      }
    }

    protected deleteLines () {
      const msg = 'Are you sure you want to delete all lines?'
      if (confirm(msg) === true) {
        this.lines = []
        this.addLine()
        this.header.sub_total = 0
        this.header.advance_received = 0
        this.header.total = 0
      }
    }

    protected async populateClientData (client: any) {
      if (Object.keys(client).length === 0 || client === null) return false
      this.populateJobs(client.agent_id)
      this.populateClientAddress(client.id)
    }

    protected async populateClientAddress (clientId = 0) {
      const response = await AddressService.getClientAddress(clientId)
      this.header.client_address = response.data.address
    }

    protected async populateCompanyAddress (companyId = 0) {
      const response = await AddressService.getCompanyAddress(companyId)
      this.header.company_address = response.data.address
      this.header.company_country = response.data.country
    }

    protected setServiceDescription (line: any, index: number) {
      if (Object.keys(line.item).length !== 0) {
        this.lines[index].description = line.item.description
        this.getTariffDetailsByItemId(line.item, index)
      }
    }

    // eslint-disable-next-line camelcase
    protected getTariffDetailsByItemId (item: { id: any, item_name: string }, index: number) {
      const itemName = item.item_name || ''

      this.lines[index].tariffs = []

      if (itemName.toLowerCase().includes('sludge')) {
        this.lines[index].quantity = this.header.oil_quantity || 0
      }

      if (itemName.toLowerCase().includes('water')) {
        this.lines[index].quantity = this.header.water_quantity || 0
      }

      if (itemName.toLowerCase().includes('barge')) {
        this.lines[index].quantity = 1
      }

      const filteredDetails = this.tariffs.filter(detail => detail.item_id === item.id)

      if (filteredDetails.length === 0) {
        this.lines[index].rate = this.lines[index].rate ?? null
      }

      if (filteredDetails.length === 1) {
        this.lines[index].rate = filteredDetails[0].rate
        this.lines[index].tariffs = filteredDetails
      }

      if (filteredDetails.length > 1) {
        this.lines[index].rate = null

        filteredDetails.forEach((tariff) => {
          this.lines[index].tariffs.push({
            value: tariff.rate,
            text: `${tariff.description} - ${tariff.rate}`
          })
        })
      }

      if (this.isEditForm) this.setTariffsForCreatedFdaItems(index)

      // Water items use calculated rate logic
      if (itemName.toLowerCase().includes('water')) {
        this.lines[index].rate_selection = 0
        this.calculateLineRate(index)
      } else {
        this.calculateLineTotal(index)
      }
    }

    protected setTariffsForCreatedFdaItems (index: number) {
      const line = this.lines[index]
      if (line.tariffs.length > 1 && Number(line.rate_selection) !== 1 && line.isEdit) {
        line.rate_selection = line.rate
      } else if (line.tariffs.length > 1 && Number(line.rate_selection) !== 1 && !line.isEdit) {
        line.rate = line.rate_selection
      }
    }

    protected calculateLineRate (index: number) {
      if (this.lines[index].rate_selection === 0) {
        this.lines[index].rate_selection = null
        this.lines[index].is_custom_rate = false
        this.lines[index].custom_rate = null

        const quantity = Number(this.lines[index].quantity)
        const totalQuantity = Number(this.header.oil_quantity) + Number(this.header.water_quantity)
        if (totalQuantity === 0) {
          alert('Please enter Oil and Water Quantity to Calculate Line Rate')
          this.lines[index].rate = null
          return null
        }

        const percentage = (quantity / totalQuantity) * 100

        // Find matching tariff based on percentage range
        const matchedTariff = this.tariffs.find(tariff => {
          if (tariff.description === '<10%' && percentage < 10) return true
          if (tariff.description === 'Between 11%-25%' && percentage >= 11 && percentage <= 25) return true
          if (tariff.description === 'Between 26%-50%' && percentage >= 26 && percentage <= 50) return true
          if (tariff.description === 'Between 51%-75%' && percentage >= 51 && percentage <= 75) return true
          if (tariff.description === '75%>' && percentage > 75) return true
          return false
        })

        this.lines[index].rate = matchedTariff ? matchedTariff.rate : null
        this.lines[index].rate_selection = matchedTariff ? matchedTariff.rate : null

        this.calculateLineTotal(index)
      } else if (this.lines[index].rate_selection === 1) {
        this.lines[index].is_custom_rate = true
        this.lines[index].custom_rate = null
        this.lines[index].amount = 0
      } else {
        this.lines[index].is_custom_rate = false
        this.lines[index].rate = this.lines[index].rate_selection
        this.calculateLineTotal(index)
      }
    }

    protected setCustomRate (index: number) {
      this.lines[index].rate = this.lines[index].custom_rate
      this.calculateLineTotal(index)
    }

    protected calculateLineTotal (index: number) {
      this.lines[index].amount = this.lines[index].quantity * this.lines[index].rate
    }

    protected saveAndPrint () {
      this.save()
      this.$nextTick(() => {
        this.print()
      })
    }

    protected saveAndClose () {
      this.save()
      this.$nextTick(() => {
        this.cancel()
        this.showComponent = false
      })
    }

    protected saveAndNew () {
      this.save()
      this.$nextTick(() => {
        this.cancel()
      })
    }

    protected save () {
      if (!this.isValidated()) return false
      const header: any = {}
      const lines: any = []
      Object.keys(this.header).forEach(key => {
        header[key] = this.header[key]
        header.created_user = AuthModule.user.fullname
        header.modified_user = AuthModule.user.fullname
        header.client_id = this.header.client.id
        header.client_name = this.header.client.name
        header.company_id = this.header.company.id
        header.company_name = this.header.company.name
        header.bank_account_id = this.header.bank_account.id
        header.bank_account_name = this.header.bank_account.name
        delete header.company
        delete header.client
        delete header.bank_account
      })
      this.lines.forEach((line, index) => {
        // eslint-disable-next-line camelcase
        const { id, isEdit, item, custom_rate, is_custom_rate, tariffs, ...lineData } = line

        lines.push({
          ...lineData,
          line_number: index + 1,
          item_id: line.item.id,
          item_name: line.item.name,
          created_user: line.created_user === null ? AuthModule.user.fullname : line.created_user,
          modified_user: AuthModule.user.fullname
        })
        line.isEdit = false
      })

      if (this.isEditForm && this.header.id !== null) this.update(header, lines)
      else this.create(header, lines)
    }

    protected create (header: any, lines: any) {
      FdaService.create(header, lines).then((response) => {
        this.header.id = response.data.id
        ToastModule.message(response.data.message);
        (this.$parent as any).populateJobs()
        this.isEditForm = true
      }).catch(error => {
        NotifyModule.set('There was a problem saving your data, Please check and retry again')
        console.log(error)
      })
    }

    protected update (header: any, lines: any) {
      FdaService.update(header, lines).then((response) => {
        ToastModule.message(response.data.message);
        (this.$parent as any).populateJobs()
      }).catch(error => {
        NotifyModule.set('There was a problem saving your data, Please check and retry again')
        console.log(error)
      })
    }

    protected isValidated () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        NotifyModule.set('There are fields that require your attention')
        return false
      }

      const lineCount = this.lines.filter(line => Object.keys(line.item).length === 0).length
      if (lineCount > 0) {
        NotifyModule.set('It appears that particulars are empty, Please check..')
        return false
      }

      return true
    }

    protected getFdaData () {
      const fda = JSON.parse(JSON.stringify(this.header))
      fda.job = JSON.parse(JSON.stringify(this.job))
      fda.items = JSON.parse(JSON.stringify(this.lines))
      fda.bank_account = JSON.parse(JSON.stringify(this.bankAccount))

      return fda
    }

    protected print () {
      const obj = this.getFdaData();
      (this.$refs.PrintFda as any).show(obj)
    }

    protected preview () {
      const fda = this.getFdaData();
      (this.$refs.PreviewFda as any).show(fda)
    }

    public cancel () {
      this.reset(this.header)
      this.isAdvanceReceived = false
      this.isEditForm = false
      this.header.client = {}
      this.header.company = {}
      this.header.job = {}
      this.header.advance_received = 0
      this.bankAccount = {}
      this.lines = []
      this.services = []
      this.companies = []
      this.clients = []
      this.jobs = []
      this.$nextTick(() => {
        this.$v.header.$reset()
      })
    }

    protected reset (obj: any) {
      for (const key in obj) {
        obj[key] = null
      }
    }
}

